import WalledContent from 'components/Common/WalledContent'
import * as React from 'react'
import { useIntl } from 'react-intl'
import SearchTilePrimaryActionButton from '../shared/SearchTilePrimaryActionButton'
import SearchTileSignUpButton from '../shared/SearchTileSignUpButton'
import TextButton from 'LuxKit/Button/TextButton'
import useHideAnytimePrices from '../../../../hooks/Offers/useHideAnytimePrices'

interface Props {
  offer: App.HotelOffer | App.HotelOfferSummary
  offerMetaData?: App.OfferListMetaData
  onSelectDatesClick?: () => void
}

function HotelSearchTileAction({ offer, offerMetaData, onSelectDatesClick }: Props) {
  const intl = useIntl()
  const hidePrice = useHideAnytimePrices(offer.type, !!offerMetaData?.hidePricing)

  const handleSelectDatesClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (hidePrice && onSelectDatesClick) {
      e.preventDefault()
      onSelectDatesClick()
    }
  }

  const actionButton = hidePrice ? (
    <TextButton nonInteractable kind="primary" onClick={handleSelectDatesClick}>
      {intl.formatMessage({
        id: 'mYW_5ONvelTb6ekAT5XM',
        defaultMessage: 'Select dates',
        description: 'Button text prompting user to select dates on hotel search tile',
      })}
    </TextButton>
  ) : (
    <SearchTilePrimaryActionButton />
  )

  return <WalledContent
    enforced={offer.walledGarden}
    wall={<SearchTileSignUpButton />}
  >
    {!offerMetaData?.extendedAvailability && actionButton}
  </WalledContent>
}

export default HotelSearchTileAction
